import { useRef, useEffect, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize';
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from "quill-mention";
import api from '../../services/api';
import EmojiPicker from 'emoji-picker-react'

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
Quill.register('modules/imageResize', ImageResize);

const QuillInputText = ({ newComment, setNewComment, commentSubmit, showEmojiPicker, setShowEmojiPicker }) => {
  const editorRef = useRef(null);
	const quillInstance = useRef(null);

	function convertMentionsToCustomFormat(html) {
    const div = document.createElement('div');
    div.innerHTML = html;

    const mentions = div.querySelectorAll('span.mention');

    mentions.forEach(span => {
      const name = span.dataset.value;
      const id = span.dataset.id;

      const formatted = `{@}[${name}](${id})`;

      const textNode = document.createTextNode(formatted);
      span.parentNode.replaceChild(textNode, span);
    });

    return div.innerHTML;
  }

	const handleEmojiSelect = (emojiObject, event) => {
    const quill = quillInstance.current;

    if (!quill) {
      console.error('Erro: Instância do Quill não disponível para inserir emoji.');
      return;
    }

    const emojiToInsert = String(emojiObject.emoji || '');

    if (emojiToInsert === '') {
      console.warn('Atenção: Emoji selecionado está vazio ou inválido. Não será inserido.');
      return;
    }

    try {
      let currentText = quill.getText();
      
      const editorLength = quill.getLength();
      let insertionIndex = editorLength;

      if (currentText.endsWith('\n')) {
        insertionIndex = editorLength - 1;

        if (insertionIndex < 0) {
            insertionIndex = 0;
        }
      }
      
      quill.insertText(insertionIndex, emojiToInsert);
      
      quill.setSelection(insertionIndex + emojiToInsert.length);

      setShowEmojiPicker(false);
    } catch (error) {
      console.error("Erro ao inserir emoji no Quill:", error);
      console.error("Detalhes do erro:", error.message, error.stack);
    }
  };

	useEffect(() => {
		if (!quillInstance.current) {
			quillInstance.current = new Quill(editorRef.current, {
				theme: "snow",
				placeholder: 'Escrever comentário...',
				modules: {
					mention: {
						allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
						mentionDenotationChars: ["@"],
						source: async function(searchTerm, renderList, mentionChar) {
							let values;

							const response = await api.get(`/api/get_suggestions_web`);
							const { suggestions } = response.data;

							values = suggestions;

							if (searchTerm.length === 0) {
								renderList(values, searchTerm);
							} else {
								const matches = [];
								for (let i = 0; i < values.length; i++)
									if (
										~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
									)
										matches.push(values[i]);
								renderList(matches, searchTerm);
							}
						}
					},
					toolbar: [],
					clipboard: {
						matcheVisual: false,
						matchers: [
							[
								Node.TEXT_NODE,
								(node, delta) => {
									const text = node.data;
									if (text.match(/(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg))/i)) {
										return { ops: [] };
									}
									return delta;
								},
							],
						],
					},
				},
			});

			quillInstance.current.on("text-change", () => {
				const editorHTML = quillInstance.current.root.innerHTML;
				const customFormatted = convertMentionsToCustomFormat(editorHTML);

				setNewComment(customFormatted);
			});
		}
	}, []);

	useEffect(() => {
		if (commentSubmit && quillInstance.current) {
      quillInstance.current.root.innerHTML = '';
		}
	}, [commentSubmit])

  return (
		<div style={{ width: '80%' }} className='mb-3'>
			<div className='form-control' ref={editorRef}></div>

			{showEmojiPicker && (
				<div className='mt-3' style={{ width: '100%' }}>
					<EmojiPicker  onEmojiClick={handleEmojiSelect} />
				</div>
			)}
		</div>
  );
}

export default QuillInputText;